import axios from 'axios';

export function fetchScreenHostTeamContext(token) {
    return axios.get(`${process.env.REACT_APP_API_URL}/screenHost/team/context`, {
        headers: { Authorization: token },
    });
}

export function getScreenHostTeam(token, ownerUserId) {
    return axios.get(`${process.env.REACT_APP_API_URL}/screenHost/team?userId=${ownerUserId}`, {
        headers: { Authorization: token },
    });
}

export function inviteScreenHostTeamMember(token, payload) {
    return axios.post(`${process.env.REACT_APP_API_URL}/screenHost/team/invite`, payload, {
        headers: { Authorization: token },
    });
}

export function updateScreenHostTeamMember(token, memberId, payload) {
    return axios.patch(`${process.env.REACT_APP_API_URL}/screenHost/team/${memberId}`, payload, {
        headers: { Authorization: token },
    });
}

export function revokeScreenHostTeamMember(token, memberId, ownerUserId) {
    return axios.delete(`${process.env.REACT_APP_API_URL}/screenHost/team/${memberId}?userId=${ownerUserId}`, {
        headers: { Authorization: token },
    });
}

export function hostRoleCanManageSettings(role) {
    return role === 'owner' || role === 'admin';
}

export function hostRoleCanManageContent(role) {
    return role === 'owner' || role === 'admin' || role === 'editor';
}

export function isTeamDelegateRole(role) {
    return role === 'admin' || role === 'editor';
}

export function isTeamDelegateSession(session = {}) {
    return Boolean(
        session.isTeamDelegate
        || session.teamMemberOnly
        || isTeamDelegateRole(session.hostRole),
    );
}

export function hostRoleCanManageTeam(role) {
    return role === 'owner';
}

export function hostRoleCanViewRevenue(role) {
    return role === 'owner';
}

export function hostRoleCanLinkScreen(role) {
    return role === 'owner' || role === 'admin';
}
